var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.51959,
    cy: 7.43365,
    r: 6.51959,
    fill: "#7BB728"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02451 9.04314L3.40415 7.60385C3.31684 7.52629 3.19842 7.48272 3.07495 7.48272C2.95147 7.48272 2.83305 7.52629 2.74574 7.60385C2.65843 7.6814 2.60938 7.78659 2.60938 7.89627C2.60938 7.95058 2.62142 8.00435 2.64481 8.05452C2.66821 8.1047 2.70251 8.15029 2.74574 8.18869L4.69764 9.92247C4.87976 10.0842 5.17394 10.0842 5.35606 9.92247L10.2965 5.53409C10.3838 5.45654 10.4329 5.35135 10.4329 5.24167C10.4329 5.13199 10.3838 5.0268 10.2965 4.94925C10.2092 4.87169 10.0908 4.82812 9.96731 4.82812C9.84383 4.82812 9.72541 4.87169 9.6381 4.94925L5.02451 9.04314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.768c65901b10ee7895ceb888d697329d.svg";
export { ForwardRef as ReactComponent };